import { CommonModule, NgForOf, NgIf } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import { BreadcrumbsComponent } from './breadcrumbs.component';

@NgModule({
  imports: [
    CommonModule,
    NgIf,
    NgForOf,
    MatToolbar,
    MatToolbarRow,
    MatIconModule,
    MatButtonModule,
    RouterLink,
  ],
  declarations: [BreadcrumbsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [BreadcrumbsComponent],
})
export class BreadcrumbsModule {}
